import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import Link from './Link';

// interface AuthDialogProps {
//   action: 'like' | 'comment' | null;
//   onClose: () => void;
// }

export function AuthDialog({ action, onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
    >
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose}></div>
      
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="relative bg-gradient-to-b from-gray-900 to-black rounded-2xl overflow-hidden max-w-lg w-full"
      >
        <div className="absolute inset-0">
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-20"
            style={{ 
              backgroundImage: action === 'like' 
                ? "url('https://images.unsplash.com/photo-1516450360452-9312f5e86fc7')"
                : "url('https://images.unsplash.com/photo-1519834089823-af2d966a0648')"
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 to-black/90 backdrop-blur-sm"></div>
        </div>

        <div className="relative p-8">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
          >
            <X className="w-6 h-6" />
          </button>

          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white mb-4">Join Our Community</h3>
            <p className="text-gray-300">
              {action === 'like'
                ? "Sign in to like and save inspirational content"
                : "Sign in to join the conversation and share your thoughts"}
            </p>
          </div>

          <div className="space-y-4">
            <Link
              to="/login"
              className="block w-full py-3 px-4 bg-amber-600 text-white text-center rounded-lg hover:bg-purple-700 transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="block w-full py-3 px-4 bg-white/10 text-white text-center rounded-lg hover:bg-white/20 transition-colors"
            >
              Create Account
            </Link>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}